document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('#gush-heat-science-page');
  if (!root) return;

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  root.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));

  root.querySelectorAll('.glossary__question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.glossary__item');
      if (!item) return;

      const isOpen = item.classList.contains('is-open');

      root.querySelectorAll('.glossary__item.is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        openItem.querySelector('.glossary__question')?.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  root.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      const target = root.querySelector(href) || document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    const heroVisual = root.querySelector('.hero__visual svg');
    if (heroVisual) {
      gsap.to(heroVisual, {
        y: -30,
        ease: 'none',
        scrollTrigger: {
          trigger: root.querySelector('.hero'),
          start: 'top top',
          end: 'bottom top',
          scrub: 1
        }
      });
    }

    const cutawayMicrospheres = root.querySelectorAll('#cutaway-diagram .microspheres circle');
    if (cutawayMicrospheres.length) {
      gsap.from(cutawayMicrospheres, {
        scale: 0,
        opacity: 0,
        stagger: 0.08,
        duration: 0.8,
        ease: 'back.out(1.4)',
        scrollTrigger: {
          trigger: root.querySelector('#cutaway-diagram'),
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      });
    }

    const microsphereRenderBits = root.querySelectorAll('#microsphere-render g, #microsphere-render > circle');
    if (microsphereRenderBits.length) {
      gsap.from(microsphereRenderBits, {
        scale: 0,
        opacity: 0,
        stagger: 0.06,
        duration: 0.6,
        ease: 'back.out(1.7)',
        scrollTrigger: {
          trigger: root.querySelector('#microsphere-render'),
          start: 'top 70%',
          toggleActions: 'play none none none'
        }
      });
    }

    const urbanRect = root.querySelector('#urban-diagram rect:nth-child(2)');
    if (urbanRect) {
      gsap.from(urbanRect, {
        x: 60,
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: root.querySelector('#urban-diagram'),
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      });
    }

    const glossaryItems = root.querySelectorAll('.glossary__item');
    if (glossaryItems.length) {
      gsap.from(glossaryItems, {
        y: 20,
        opacity: 0,
        stagger: 0.08,
        duration: 0.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: root.querySelector('.glossary__list'),
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    }

    const closingTitle = root.querySelector('.closing__title');
    if (closingTitle) {
      gsap.from(closingTitle, {
        y: 40,
        opacity: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: root.querySelector('.closing'),
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    }
  }
});
